import React, {useEffect} from 'react';
import * as Icon from 'ubs-icons';
import {COLOR} from '../common/constant';
import {isInApp, showToastError} from '../common/function';

const SUPPORT_EVENT = 'support|portal|connect';

// Support portal base URL — hardcoded for now (no env wiring yet). The backend
// returns only the signed /connect path; we prepend this host. Change per
// environment (e.g. http://localhost:5173 for local).
const SUPPORT_PORTAL_URL = 'https://support.superworks.com';

/**
 * Dynamic "Contact Support" button for the support portal.
 *
 * Renders only when the company has the portal enabled AND the user is
 * eligible (both flags come from the login payload). On click it asks the
 * backend for a signed connect PATH, prepends SUPPORT_PORTAL_URL, and opens the
 * portal in a new tab from the socket response.
 *
 * ⚠️ The tab is opened inside the (async) socket response, which is outside the
 * click's user-gesture stack — browsers may treat window.open here as a popup
 * and block it. If that happens the user must allow popups for this site.
 *
 * All support-portal logic lives here (not the module's store/actions); the
 * host module supplies its own `sendData` + `useSocket` (UTimerWidget pattern).
 */
const USupportButton = ({enabled, eligible, sendData, useSocket}) => {
    const {off, refresh} = useSocket(res => {
        if (res && !res?.error && !res?.data?.error) {
            switch (res.event) {
                case SUPPORT_EVENT: {
                    if (res?.data?.result?.path) window.open(`${SUPPORT_PORTAL_URL}${res.data.result.path}`, '_blank');
                    break;
                }
            }
        } else {
            showToastError(res?.data?.error || 'Unable to open the support portal.');
        }
    });

    useEffect(() => {
        refresh();
        return () => {
            off();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (!enabled || !eligible || isInApp()) return null;

    const contactSupport = () => {
        sendData(SUPPORT_EVENT, {_t: Date.now()}, true);
    };

    return (
        <p className="u_support-text" onClick={contactSupport}>
            <Icon.Support fill={COLOR.u_green} size={18} className="u_mr-10"/> Contact Support
        </p>
    );
};

export default USupportButton;
